import React from "react";
import Table from "@material-ui/core/Table";
import TableCell from "@material-ui/core/TableCell";
import TableRow from "@material-ui/core/TableRow";
import TableBody from "@material-ui/core/TableBody";
import styles from "./styles";
import appConstants from "../../../../../appConstants";
import { withStyles } from "@material-ui/core/styles";
import { getServiceLevel, getServiceWindow } from "../../utils/utils";
import ViewStopImages from "./ViewStopImages"
import Events from "../../../../../utilities/EventEmitter";
import { IconButton } from "@material-ui/core";
import { ImageOutlined } from "@material-ui/icons";
import StyledToolTip from "../../../../common/StyledToolTip"; 

const CollapsibleDetails = withStyles(styles)(
  ({ classes, data, geofenceWindow, viewStopImages, routeData, glEventHub }) => {
    const renderPickupNumbers = () => {
      return data.pickupIdList.map((pickupId, index, array) => (
        <React.Fragment key={pickupId}>
          <span
            onClick={() => glEventHub.emit('showPickupDetails', pickupId)}
            className={classes.clickable}
          >
            {data.pickupNumberIdList[index]?.pickupNumber ?? ''}
          </span>
          {index < array.length - 1 && <span>, </span>}
        </React.Fragment>
      ));
    };

    const renderProNumbers = () => {
      return data.shipments.map((pro, index, array) => (
        <React.Fragment key={pro.proId}>
          <span onClick={showProDetails(pro)} className={classes.clickable}>
            {pro.proId}
          </span>
          <StyledToolTip title="View pro images">
            <IconButton className={classes.imageButton} onClick={viewStopImages(pro.proId)}>
              <ImageOutlined />
            </IconButton>
          </StyledToolTip>
          {index < array.length - 1 && <span>; </span>}
        </React.Fragment>
      ));
    };
    const getProDetails = () => {
      if (data.stopType === appConstants.STOP_TYPE.Pickup) {
        return {
          proDetailsLabel: 'Pickup Number(s)',
          proDetailsValue: renderPickupNumbers()
        };
      }
      return {
        proDetailsLabel: 'Pro Number(s)',
        proDetailsValue: renderProNumbers()
      };
    };

    const showProDetails = (pro) => () => {
      Events.emit('showProDetails', {
        stopId: data.stopId,
        proId: pro.proId,
        driverRouteDetails: routeData,
        shipmentId: pro.shipmentId
      });
    };

    const getGeofenceTime = () => {
      let text = '';
      if (geofenceWindow.geoFenceArrivalTime) {
        text += `${geofenceWindow.geoFenceArrivalTime} - `;
      }
      if (geofenceWindow.geoFenceDepartureTime) {
        text += `${geofenceWindow.geoFenceDepartureTime}`;
      }
      return text;
    };
    const serviceLevel = getServiceLevel(data);
    const { proDetailsLabel, proDetailsValue } = getProDetails();
    const geofenceTime = getGeofenceTime();
    return (
      <React.Fragment>
        <Table size="small">
          <TableBody>
            <TableRow className={classes.tableRow}>
              <TableCell className={classes.tableHeaderCell}>Service Window</TableCell>
              <TableCell className={classes.tableHeaderCell}>Service Level</TableCell>
              <TableCell className={classes.tableHeaderCell}>Bills</TableCell>
              <TableCell className={classes.tableHeaderCell}>HU</TableCell>
              <TableCell className={classes.tableHeaderCell}>Pieces</TableCell>
              <TableCell className={classes.tableHeaderCell}>Weight</TableCell>
            </TableRow>
            <TableRow className={classes.tableRow}>
              <TableCell className={classes.enrouteTo}>{getServiceWindow({ data })}</TableCell>
              <TableCell className={classes.tableDataCell}>{serviceLevel}</TableCell>
              <TableCell className={classes.tableDataCell}>{data.numberOfBills}</TableCell>
              <TableCell className={classes.tableDataCell}>{data.hu}</TableCell>
              <TableCell className={classes.tableDataCell}>{data.pieces}</TableCell>
              <TableCell className={classes.tableDataCell}>{data.weight}</TableCell>
            </TableRow>
          </TableBody>
        </Table>
        <div className={classes.detailSection}>
          <div className={classes.proDetailsContainer}>
            <span className={classes.proDetailsHeaderCell}>{proDetailsLabel}</span>
            <span className={classes.proDetailsDataCell}>{proDetailsValue}</span>
          </div>
          {geofenceTime ? (
            <div className={classes.proDetailsContainer}>
              <span className={classes.proDetailsHeaderCell}>Geofence</span>
              <span className={classes.proDetailsDataCell}>{geofenceTime}</span>
            </div>
          ) : null}
        </div>
        <ViewStopImages onClick={viewStopImages()} />
      </React.Fragment>
    );
  }
);

export default CollapsibleDetails;
